import React, { useState, useEffect, useCallback, useRef } from 'react'
import Table from '../../../components/Table';
import DocUploadModal from '../../../components/Modal/DocUploadModal';
import { environment } from '../../../env';
import axios from 'axios';
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import { Form } from 'reactstrap'
import 'react-toastify/dist/ReactToastify.css';
import _ from "lodash";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction, getBuildingAction } from '../../../redux/actions/Index';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Eye, Users, User } from '@phosphor-icons/react';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import PathName from '../../../components/PathName/PathName';

const SoldHistory = () => {
    const [update, setUpdate] = useState(false);
    const [emptyerr, setEmptyerr] = useState(false);
    const [filterBuilding, setFilterBuilding] = useState([]);
    const [GalaFilters, setGalaFilters] = useState([]);
    const [GalaFil, setGalaFil] = useState([]);
    const [SubGalaFil, setSubGalaFil] = useState([]);
    const [galafilterdata, setgalafilterdata] = useState();
    const [selectedBuildingIdState, setSelectedBuildingIdState] = useState();
    const dispatch = useDispatch();
    const apiTimeOut = useRef(null);

    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const galaList = useSelector((state) => state?.ModalReducer?.galaList);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const soldGalas = useSelector((state) => state?.ModalReducer?.soldGalaList);
    let projectName = projectList?.filter((data, i) => data.id == userProject)

    var soldGalaList = soldGalas?.filter(item => item.resell_area != 0 && item.project.id == userProject)
    if (SubGalaFil) {
        var subGalaFilter = Array.from(new Set(SubGalaFil.map((item) => item.sub_gala_name).sort((a, b) => a - b)))
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm();

    const ordinal = (i) => {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";

        }
        return i + "th";
    }

    const getBuildingData = () => {
        try {
            axios.get(`${environment.baseUrl}building/`).then(res => {
                dispatch(getBuildingAction(res.data));
                setFilterBuilding(res.data)
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (filterBuilding == undefined || filterBuilding?.length == 0) {
            getBuildingData();
        }
    }, [])

    const columns = [
        {
            name: 'Status',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={`${row.ownership === 1 && 'icon-bg-green icon-color-green '} ${row.ownership === 2 && 'icon-bg-yellow icon-color-yellow'} ${row.ownership == 3 && 'status-bg-blue status-color-blue'} ${row.ownership >= 4 && 'bg-info text-white'}   rounded-pill status-box rounded fs-4`}>{`${ordinal(row.ownership)} Owner`}</label>
            </div>,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Owner Type',
            selector: row => <div className="d-flex justify-content-between align-items-center gap-3 " >
                <span>{row?.ownertype == "Self" ? <User size="26" className='text-base-red' /> : row?.ownertype == "Joined" && <Users size="26" className='status-color-blue' />}</span>
                <label className='fs-3'>{row?.ownertype}</label>
            </div >,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Party Name',
            selector: row => row.Investors?.name,
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Created On',
            selector: row => moment(row.created_at).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building No',
            selector: row => row.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },

        {
            name: 'Gala No',
            selector: row => Number(row.gala?.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }, {
            name: 'Sub Gala',
            selector: row => row.sub_gala_name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.resell_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Upload',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <DocUploadModal type={"soldgala"} soldGalaId={row?.id} />
            </div>,
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <Link to={{ pathname: `/SoldGalas/${row.id}`, state: { customProp: 'Hello' } }} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="24" className='icon-color-green' /></Link>
            </div>,
        },
    ];

    // var selectedProjectName = watch("project");
    var selectedBuildingId = watch("building");
    var selectedGala = watch("gala_no")
    var selectedsGala = watch("sub_gala_no")
    var selname = watch("search")

    selname = selname == undefined ? "" : selname // do not remove

    useMemo(() => {
        let buildings = buildingList?.filter((data, i) => data.project.id == userProject)
        setFilterBuilding(buildings)
    }, [userProject])

    useMemo(() => {
        if (selectedGala || selectedBuildingId || selname) {
            const SearchUrl = `${environment.baseUrl}sold-gala-filter/?gala=${selectedGala == undefined ? "" : selectedGala}&building=${selectedBuildingId == undefined ? "" : selectedBuildingId}&project=${projectName[0]?.name}&investor=${selname == undefined ? "" : selname}`;
            const result = axios(SearchUrl).then((res) => {
                if (res?.data?.length > 0) {
                    const dat = res.data?.filter(item => item.resell_area != 0 && item.project.id == userProject)
                    if (dat.length) {
                        setEmptyerr(false)
                        setGalaFilters(dat);
                    } else {
                        setEmptyerr(true);
                    }
                    dispatch(loaderAction(false))
                } else {
                    setEmptyerr(true);
                    dispatch(loaderAction(false))
                }
            })
        } else {
            setGalaFilters(soldGalaList)
        }
    }, [selectedGala, selectedBuildingId])

    useMemo(() => {
        if (apiTimeOut.current) {
            clearTimeout(apiTimeOut.current)
        }

        if (selname && selname != "") {
            apiTimeOut.current = setTimeout(() => {
                const SearchUrl = `${environment.baseUrl}sold-gala-filter/?gala=${selectedGala == undefined ? "" : selectedGala}&building=${selectedBuildingId == undefined ? "" : selectedBuildingId}&project=${projectName[0]?.name}&investor=${selname == undefined ? "" : selname}`;
                const result = axios(SearchUrl).then((res) => {
                    if (res?.data?.length > 0) {
                        const dat = res.data?.filter(item => item.resell_area != 0)
                        if (dat.length) {
                            setEmptyerr(false)
                            setGalaFilters(dat);
                        } else {
                            setEmptyerr(true);
                        }
                        dispatch(loaderAction(false))
                    } else {
                        setEmptyerr(true);
                        dispatch(loaderAction(false))
                    }
                })

                apiTimeOut.current = null;
            }, 2000)
        } else {
            setGalaFilters(soldGalaList)
        }

    }, [selname])

    useEffect(() => {
        if (selectedBuildingId != undefined) {
            setSelectedBuildingIdState(selectedBuildingId);
        }
    }, [selectedBuildingId])

    useMemo(() => {
        var galaselected;
        {
            var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
            setFilterBuilding(projectBuilding);
            galaselected = soldGalaList?.filter((galalist) => galalist.project.name == projectName[0]?.name);
            // setGalaFilters(galaselected);
        }
        if (selectedBuildingId) {
            galaselected = soldGalaList?.filter((galalist) => galalist.building.building_no == selectedBuildingId);
            var galaselectedd = galaList?.filter((galalist) => galalist.building.building_no == selectedBuildingId);
            setGalaFil(galaselectedd);
            // setGalaFilters(galaselected);
        } else {
            if (projectName) {
                return
            }
            else {
                setGalaFilters([]);
            }
        }
        if (selectedGala) {
            var gala = galaList.filter((data, i) => data.gala_no == selectedGala)
            var galall = galaList.filter((data, i) => data.gala_no == selectedGala && data.building.building_no == selectedBuildingId)
            galaselected = soldGalaList?.filter((galalist) => galalist?.gala?.gala_no == selectedGala & galalist.building.building_no == selectedBuildingId);
            setSubGalaFil(galaselected)
            setgalafilterdata(galall[0])
            // setGalaFilters(galaselected);
        }
        if (selectedsGala) {
            galaselected = soldGalaList?.filter((galalist) => galalist?.sub_gala_name == selectedsGala && galalist?.gala?.gala_no == selectedGala && galalist.building.building_no == selectedBuildingId)
            // setGalaFilters(galaselected);
            if (galaselected.length == 0) {
                toast.warn('Data Not Found !', {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                });
            }
        }
        setGalaFilters(galaselected);
    }, [selectedBuildingId, selectedGala, selectedsGala])

    useEffect(() => {
        soldGalaList = soldGalas?.filter(item => item.resell_area == item.sold_gala_area)
        setGalaFilters(soldGalaList)
    }, [soldGalas]);

    if (soldGalaList) {
        var newData = Array.from(new Set(soldGalaList.map((item) => item.ownership).sort((a, b) => a - b)))
    }

    const ownerstatus = (e) => {
        if (e.target.value !== "") {
            const filterData = soldGalaList.filter((item) => {
                return item.ownership == e.target.value
            })
            setGalaFilters(filterData)
        } else {
            setGalaFilters(soldGalaList)
        }

    }
    const clearFilter = () => {
        setGalaFilters(soldGalaList);
        reset({
            "search": "",
            "building": "",
            "gala_no": "",
            "sub_gala_no": ""
        })
        if (selectedBuildingId.length > 0 || selectedGala.length > 0 || selectedsGala != 0) {
            toast.success('Filter Clear Successfully !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
            });
        }
        setGalaFil([])
        setSelectedBuildingIdState();

    }
    return (
        <>
            <PathName />
            <ToastContainer />
            <Form >
                <div className='my-4 row'>
                    <div className='col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-2 pb-3 pt-1'>
                        <div className="mt-1  d-flex gap-3">
                            <input
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                type='search'
                                autoComplete='off'
                                placeholder='Search Party Name...'
                                {...register('search')}
                            />
                        </div>
                    </div>
                    {/* <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("project", { required: true, onChange: (e) => { reset({ "building": "", "gala_no": "", "project": e.target.value }) } })}
                            >
                                <option value="">Project Name</option>
                                {projectList?.map((data, i) => {
                                    return <option value={data.name} key={i}>{data.name}</option>;
                                })}
                            </select>
                        </div>
                    </div> */}
                    <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("building", { required: true, onChange: (e) => { reset({ "building": e.target.value, "gala_no": "", "sub_gala_no": "" }) } })}
                            >
                                <option value="">Building Number</option>
                                {filterBuilding?.sort((a, b) => a?.building_no?.localeCompare(b.building_no))?.map((data, i) => {
                                    return (
                                        <option value={data.building_no} key={i}>{data.building_no}</option>
                                    );
                                })}
                            </select>
                        </div>
                        {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
                        <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("gala_no", { onChange: (e) => { reset({ "building": selectedBuildingIdState, "gala_no": e.target.value, "sub_gala_no": "" }) } })}
                            >
                                <option value="">Gala No</option>
                                {GalaFil?.sort((a, b) => (a?.gala_no || 0) - (b?.gala_no || 0))?.map((data, i) => {
                                    return (
                                        <option value={data?.gala_no} key={i}>{data?.gala_no}</option>
                                    );
                                })}
                            </select>
                        </div>
                        {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
                        <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-2 col-lg-2 col-xl-2 pb-3 pt-1'>
                        <div className="mt-1  d-flex gap-3">
                            <select
                                id="role_type"
                                name="role_type"
                                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                {...register("sub_gala_no", { required: true })}
                            >
                                <option value="">Sub Gala Name</option>
                                {subGalaFilter?.sort((a, b) => a.localeCompare(b))?.map((data, i) => {
                                    return (
                                        <option value={data} key={i}>{data}</option>
                                    );
                                })}
                            </select>
                        </div>
                        {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
                        <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-1 col-lg-1 col-xl-1 pb-3 pt-1'>
                        <button type="button" className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary" onClick={clearFilter}><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Clear</span></button>
                    </div>
                </div>
            </Form>
            <SuccessPopups />
            <div className="bg-white p-4 p-md-4 p-lg-5 p-xl-5 d-flex gap-5 flex-column rounded-5 mt-1 mb-5">
                <div className="">
                    <div className="d-flex justify-content-between align-items-start align-items-md-center align-content-lg-center align-items-xl-center  flex-column flex-md-row flex-lg-row flex-xl-row">
                        <div className='pb-md-5 pb-lg-5 pb-xl-5'>
                            <h1 className='title-font-bold '>Sold Gala's History</h1>
                        </div>
                        <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
                            <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                                <select
                                    id="ProposalStatus"
                                    name="Proposal_Status"
                                    className="p-3 select-width   border-radius-10 shadow-none  fs-4 title-font-500 fs-2 modal-input "
                                    {...register("proposal_status", { onChange: (e) => { ownerstatus(e) } })}
                                >
                                    <option value="">Select Status</option>
                                    {newData?.map((data, i) => {
                                        return <option value={data} key={i}>{data} Owner</option>;
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>

                    {soldGalaList?.[0] == undefined ? <EmptyTable /> : emptyerr == true ? <EmptyTable /> : <Table columns={columns} data={GalaFilters?.length > 0 ? GalaFilters : soldGalaList} />}
                </div>
            </div>

        </>
    )
}

export default SoldHistory